module.exports = __webpack_public_path__ + "img/icone-john-deere.b99a4452.svg";